module.exports = __webpack_public_path__ + "static/media/footer_animation.9c997960.svg";